class BaoProductGrid extends window.BAO.CustomElement() {
  setupListeners () {
    this.facetsWrapper = this.els?.facetsWrapper?.element
    this.stickyReference = this.els?.stickyReference?.element

    if (!this.facetsWrapper || !this.stickyReference) return

    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
    this.recalculateStickyThreshold = this.recalculateStickyThreshold.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll, { passive: true })
    this.listeners.add(window, 'resize', this.onResize, { passive: true })
    this.listeners.add(window, 'load', this.onResize)
    this.listeners.add(window, 'pageshow', this.onResize)

    window.requestAnimationFrame(() => {
      this.recalculateStickyThreshold()
      this.updateStickyState()
    })
  }

  onScroll () {
    if (this.isTicking) return

    this.isTicking = true

    window.requestAnimationFrame(() => {
      this.updateStickyState()
      this.isTicking = false
    })
  }

  onResize () {
    this.recalculateStickyThreshold()
    this.updateStickyState()
  }

  recalculateStickyThreshold () {
    if (!this.facetsWrapper || !this.stickyReference) return

    this.stickyTop = Number.parseInt(window.getComputedStyle(this.facetsWrapper).top, 10) || 0
    this.stickyStart = window.scrollY + this.stickyReference.getBoundingClientRect().top - this.stickyTop
  }

  updateStickyState () {
    if (!this.facetsWrapper) return

    if (typeof this.stickyStart !== 'number' || typeof this.stickyTop !== 'number') {
      this.recalculateStickyThreshold()
    }

    const wrapperTop = this.facetsWrapper.getBoundingClientRect().top
    const isSticky = window.scrollY >= this.stickyStart && wrapperTop <= this.stickyTop

    this.facetsWrapper.dataset.isSticky = isSticky ? 'true' : 'false'
  }
}

if (!customElements.get('bao-product-grid')) {
  customElements.define('bao-product-grid', BaoProductGrid)
}
